import { startOfDay } from 'date-fns';

import {
  DateFormControlViewModel,
  DictDateFormControlViewModel,
} from '../../view-model/FormControlViewModel';

// TODO move to utils or typeguards
function assertDate(value: unknown): asserts value is Date | string | number {
  if (Number.isNaN(Date.parse(value as string))) {
    throw new TypeError(`Wrong type of Date value`);
  }
}

const updateDate = (
  value: any,
  control: DateFormControlViewModel | DictDateFormControlViewModel
): Date | null => {
  if (value) {
    assertDate(value);
    if (
      control.format
        .split(/[^DMYhms]+/)
        .some(i => ['hh', 'h', 'HH', 'H'].includes(i))
    ) {
      return new Date(value);
    } else {
      return startOfDay(new Date(value));
    }
  } else {
    return value;
  }
};

export default updateDate;
